<template lang="pug">
.asset-search-wrapper
	.asset-search
		.search-input
			.icon-search
			input(
				type='text'
				ref='search'
				v-model='query'
				:placeholder='placeholder'
				@blur='wait( close )'
				@keydown='wait( search )'
				@keydown.enter='search'
			)
			.icon-close(:class='{ active : query.length }' @click='clear')
		.buttons
			.search-button(
				v-for='button in buttons'
				@click='toggleDropdown( button.name )'
				:class='{ open : openDropdown === button.name }'
			)
				div.icon(:class='button.icon')
				p {{ button.label }}
				.dropdown-download(
					:class='{ open : openDropdown === button.name }'
					@mouseleave='setDropdownTimer'
					@mouseenter='clearDropdownTimer'
				)
					.dropdown-body
						.top
							div.icon(:class='button.icon')
							p {{ button.label }}
						.option(@click='emitDownload( button.name, "filtered" )')
							.bubble
							p Download as filtered
						.option(@click='emitDownload( button.name, "all" )')
							.bubble
							p Download all
						.option(@click='emitDownload( button.name, "new" )')
							.bubble
							p Download with new filters
			.search-button(@click='emitEvent( "settings" )')
				div.icon(:class='settingsButton.icon')
				p {{ settingsButton.label }}

</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue';
import SimpleSearch from '@/components/SimpleSearch';

export default {
	name : 'asset-search',

	extends : SimpleSearch,

	props : {
		buttons : {
			type    : Array,
			default : () => [
				{
					name     : 'pdf',
					icon     : 'icon-download',
					label    : 'Download as PDF',
					dropdown : true,
				},
				{
					name     : 'csv',
					icon     : 'icon-csv',
					label    : 'Download as CSV',
					dropdown : true,
				},
			]
		}
	},

	data : () => ( {
		openDropdown   : '',
		settingsButton : {
			name  : 'settings',
			icon  : 'icon-gear',
			label : 'Table Settings',
		},

		timerId : null,
	} ),

	methods : {
		toggleDropdown( name ) {

			if ( this.openDropdown === name ) {
				this.openDropdown = '';
				return;
			}

			this.openDropdown = name;
		},

		emitDownload( fileType, filterOption ) {
			this.$emit( fileType, filterOption );
		},

		emitEvent( event ) {
			this.$emit( event, event );
		},
		setDropdownTimer() {
			this.timerId = window.setTimeout( () => {
				this.openDropdown = '';
			}, 400 );
		},

		clearDropdownTimer() {
			if ( this.timerId ) {
				window.clearTimeout( this.timerId );
			}
		},
	}

};
</script>

<style scoped lang="scss">
.asset-search-wrapper {

	.asset-search {
		display: flex;
		align-items: center;
		position: relative;
		padding: 10px;
		border-radius: 15px;
		box-shadow: $box-shadow__search-bar;
		margin: 15px 30px;
		z-index: 3;
		background: white;

		// Minus the wifth of the the sidenav and margin on assert-search
		// max-width: calc( 100vw - 360px );

		.search-input {
			display: flex;
			align-items: center;
			flex: 1 1 0;

			input {
				background: transparent;
				font-family: 'Poppins', sans-serif;
				// font-style: italic;
				font-weight: 500;
				font-size: 14px;
				flex: 1 0 auto;
				color: $input-color;

				&::placeholder {
					color: $input-color;
				}
			}

			.icon-search {
				margin: 0 10px;
				margin-right: 15px; // ? Account for the 10px in padding on the left due to the container

				&::before {
					color: $input-color;
					font-size: 21px;
				}
			}

			.icon-close {
				opacity: 0;
				pointer-events: none;

				&.active {
					opacity: 1;
					pointer-events: all;
				}
			}

		}

		.buttons {
			display: flex;

			.search-button {
				display: flex;
				align-items: center;
				cursor: pointer;
				margin-right: 25px;

				// Used To line up download csv button with the dropdown
				&:nth-child(2) {

					.dropdown-download {

						.dropdown-body {
							transform: translate( -165px, -25px);
						}
					}
				}

				&:last-child {
					margin-right: 15px; // ? Account for the 10px padding on assert-search

					.icon {

						&::before {
							color: $input-color;
						}
					}

					p {
						color: $input-color;
					}
				}

				.icon {
					font-size: 22px;
					margin-right: 10px;

					&::before {
						color: $color-primary;
					}
				}

				.icon-download {
					margin-bottom: 5px;
				}

				p {
					font-size: 14px;
				}

				> p {
					color: $color-primary;
				}

				.dropdown-download {
					position: relative;
					opacity: 0;
					pointer-events: none;

					&.open {
						opacity: 1;
						pointer-events: all;
					}

					.dropdown-body {
						position: absolute;
						background: white;
						box-shadow: $box-shadow-primary;
						border-radius: 15px;
						border-top-left-radius: 0px;
						border-top-right-radius: 0px;
						transform: translate( -157px, -25px);
						overflow: hidden;

						.top {
							display: flex;
							align-items: center;
							padding: 14px 10px;

							.icon {

								&::before {
									color: $input-color;
								}
							}

							p {
								font-weight: 600;
							}
						}

						.option {
							min-width: 180px;
							padding: 5px 10px;
							color: #50606E;
							font-size: 14px;
							display: flex;
							align-items: center;
							cursor: pointer;

							&:hover {
								background: rgba( $color-primary, .28 );
								font-weight: 600;

								.bubble {
									border-color: $color-primary;
									border-width: 3px;
								}

								p {
									color: $color-primary;
								}
							}

							&.selected {
								background: rgba( $color-primary, .28 );
								font-weight: 600;

								.bubble {
									border-color: $color-primary;
									border-width: 3px;
								}

								p {
									color: $color-primary;
								}
							}

							.bubble {
								border: 2px solid rgba($input-color, .68);
								height: 15px;
								min-width: 15px;
								border-radius: 50%;
								margin-right: 10px;
							}

						}
					}
				}
			}

		}

	}
}
</style>
